import { type ChangeEvent, type DragEvent, useId, useState } from "react";
import { IconUpload } from "@tabler/icons-react";
import styles from "./FileDropInput.module.css";
import Text from "./Text";
// @ts-expect-error pure js
import { classnames } from "../../utils";

interface FileDropInputProps {
  onFiles: (files: File[]) => void;
  accept?: string;
  multiple?: boolean;
  disabled?: boolean;
  text?: string;
  format?: string;
  hasError?: boolean;
  className?: string;
}

export default function FileDropInput({
  onFiles,
  accept,
  multiple = false,
  disabled = false,
  text = "Déposez vos fichiers",
  format = "Format PNG, JPG, JPEG, PDF",
  hasError = false,
  className,
}: FileDropInputProps) {
  const id = useId();
  const [highlight, setHighlight] = useState(false);

  function emit(fileList: FileList | null) {
    if (!fileList || fileList.length === 0) return;
    onFiles(Array.from(fileList));
  }

  function handleChange(event: ChangeEvent<HTMLInputElement>) {
    emit(event.target.files);
    event.target.value = "";
  }

  function handleDrop(event: DragEvent<HTMLLabelElement>) {
    event.preventDefault();
    setHighlight(false);
    if (disabled) return;
    emit(event.dataTransfer.files);
  }

  return (
    <>
      <input
        type="file"
        id={id}
        className={styles.input}
        accept={accept}
        multiple={multiple}
        disabled={disabled}
        onChange={handleChange}
      />
      <label
        htmlFor={id}
        className={classnames(
          styles.label,
          highlight && styles.highlight,
          hasError && styles.error,
          className,
        )}
        onDragOver={(event) => {
          event.preventDefault();
          if (!disabled) setHighlight(true);
        }}
        onDragLeave={() => setHighlight(false)}
        onDrop={handleDrop}
      >
        <IconUpload className={styles.icon} />
        <div>
          <Text variant="deci" weight="medium">
            {text}
          </Text>
          <Text variant="micro" weight="medium" color="muted">
            {format}
          </Text>
        </div>
      </label>
    </>
  );
}
